import BigNumber from 'bignumber.js';
import { DECIMAL_PLACES_BTC } from '../const';

export function formatBtc(value: BigNumber) {
  return value
    .decimalPlaces(DECIMAL_PLACES_BTC, BigNumber.ROUND_DOWN)
    .toFixed();
}
